export const timelineEvents = {
  'version': { icon: 'code-branch' },
  'step-workflow-group-approval': { icon: 'step-forward' },
  'add-group': { icon: 'user-friends' },
  'stop-workflow': { icon: 'stop' },
  'delete-workflow': { icon: 'trash-alt' },
  'resume-workflow': { icon: 'play' },
  'step-workflow-approval': { icon: 'thumbs-up' },
  'step-workflow-delegate': { icon: 'exchange-alt' },
  'step-workflow-sign': { icon: 'signature' },
  'step-workflow-delegate-and-sign': { icon: 'exchange-alt' },
  'change-participant': { icon: 'exchange-alt' },
  'assign': { icon: 'wrench' },
  'reset-status': { icon: 'undo' },
  'video-validated': { icon: 'thumbs-up' },
  'video-uploaded': { icon: 'video' },
  'video-rejected': { icon: 'times' },
  'comment-delete': { icon: 'trash-alt' },
  'collab-message': { icon: 'comments' },
  'delegate': { icon: 'user' },
  'delegate-group': { icon: 'user' },
  'grab': { icon: 'hand-rock' },
  'document-canceled': { icon: 'slash' },
  'vobo-approved': { icon: 'thumbs-up', color:'success' },
  'vobo-rejected': { icon: 'thumbs-down', color:'danger' },
  'reviewed': { icon: 'search' },
  'document-replace': { icon: 'remove-format' },
  'validate': { icon: 'paper-plane' },
  'review': { icon: 'search' },
  'comment': { icon: 'comment' },
  'extra': { icon: 'file-upload' },
  'create': { icon: 'plus' },
  'create-word': { icon: 'plus' },
  'create-questionnaire': { icon: 'plus' },
  'create-migrated': { icon: 'plus' },
  'create-template': { icon: 'plus' },
  'send-fill': { icon: 'paper-plane' },
  'pagare-blockchain': { icon: 'cubes' },
  'sign': { icon: 'signature' },
  'ask-delegation': { icon: 'hand-paper' },
  'external-link-send': { icon: 'link' },
  'extra-remove': { icon: '' },
  'view': { icon: 'eye' },
  'invite': { icon: 'hands-helping' },
  'attachment': { icon: 'uplaod' },
  'replace': { icon: 'remove-format' },
  'external-link-save': { icon: 'link' },
  'certificate': { icon: 'certificate' },
  'certificate-nom': { icon: 'certificate' },
  'negotiation': { icon: 'balance-scale' },
  'negotiation-final': { icon: 'balance-scale' },
  'word-version': { icon: 'file-word' },
  'word-online-version': { icon: 'file-word' },
  'converted-to-pdf': { icon: 'file-pdf' },
  'fill': { icon: 'edit' },
  'fill-all': { icon: 'edit' },
  'sign-all': { icon: 'signature' },
  'blockchain': { icon: 'lock' },
  'send-negotiation': { icon: 'paper-plane' },
  'send-to-negotiation': { icon: 'paper-plane' },
  'send-sign': { icon: 'paper-plane' },
  'send': { icon: 'paper-plane' },
  'send-accept': { icon: 'thumbs-up' },
  'add-collaborator': { icon: 'user-check' },
  'download': { icon: 'download' },
  'negotiate': { icon: 'handshake' },
  'variables-completed': { icon: 'edit' },
  'set-expire': { icon: 'ban' },
  'reference-document': { icon: 'link' },
  'save-document': { icon: 'edit' },
  'edit-document': { icon: 'edit' },
  'unlink-document': { icon: 'unlink' },
  'opened-after-delegation': { icon: 'edit' },
  'contract-download': { icon: 'download' },
  'document-finalized': { icon: 'lock' },
  'validate-attachment': { icon: 'check' },
  'accept': { icon: 'thumbs-up' },
  'reject': { icon: 'thumbs-down' },
  'reject-attachment': { icon: 'thumbs-down' },
  'contract-expired': { icon: 'times' },
  'send-sign-order': { icon: 'paper-plane' },
  'send-fill-order': { icon: 'paper-plane' },
  'send-download': { icon: 'download' },
  'vobo-reset': { icon: 'undo' },
  'vobo-revoked': { icon: 'times' },
  'vobo-overwritten': { icon: 'times' },
  'archive': { icon: 'archive' },
  'unarchive': { icon: 'box-open' },
  'delegate-signature': { icon: 'user' },
  'milestone-created': { icon: 'square' },
  'milestone-deleted': { icon: 'minus-square' },
  'milestone-completed': { icon: 'check-square' },
  'milestone-reset': { icon: 'undo' },
  'milestone-updated': { icon: 'check-square' },
  'milestone-attachment-delete': { icon: 'minus-square' },
  'milestone-attachment-add': { icon: 'check-square' },
  'reset-to-inprogress': { icon: 'undo' },
  'uploaded-identity': { icon: 'camera' },
  'validated-identity': { icon: 'check' },
  'downloaded-confidential': { icon: 'user-secret' },
  'remove-collaborator': { icon: 'user-times' },
  'grab-vobo': { icon: 'hand-rock' },
  'quick-vobo-approved': { icon: 'thumbs-up', color:'success'  },
  'quick-vobo-rejected': { icon: 'thumbs-down', color:'danger' },
  'voted-for': { icon: 'thumbs-up' },
  'voted-against': { icon: 'thumbs-down' },
  'voted-abstention': { icon: 'hand-paper' },
  'add-voter': { icon: 'user-check' },
  'add-voters': { icon: 'user-check' },
  'remove-voter': { icon: 'user-times' },
  'cancel-voting': { icon: 'times' },
  'started-voting': { icon: 'person-booth' },
  'voter-viewed-contract': { icon: 'eye' },
  'negotiation-taken': { icon: 'hand-rock' },
  'accepted-version': { icon: 'thumbs-up' },
  'everyone-accepted': { icon: 'thumbs-up' },
  'email-read': { icon: 'envelope-open-text' },
  'contract-ipfs': { icon: 'shield-alt' },
  'blockchain-write-clause': { icon: 'cubes' },
  'blockchain-set-clause-pay': { icon: 'cubes' },
  'blockchain-add-condition': { icon: 'cubes' },
  'blockchain-register-member': { icon: 'cubes' },
  'blockchain-create-event': { icon: 'cubes' },
  'blockchain-sign': { icon: 'cubes' },
  'blockchain-sign-all': { icon: 'cubes' },
  'blockchain-fund-contract': { icon: 'cubes' },
  'blockchain-create-contract': { icon: 'cubes' },
  'blockchain-write-clause-init': { icon: 'cube' },
  'blockchain-set-clause-pay-init': { icon: 'cube' },
  'blockchain-add-condition-init': { icon: 'cube' },
  'blockchain-register-member-init': { icon: 'cube' },
  'blockchain-create-event-init': { icon: 'cube' },
  'blockchain-release-token': { icon: 'cube' },
  'blockchain-sign-init': { icon: 'cube' },
  'blockchain-sign-all-init': { icon: 'cube' },
  'blockchain-fund-contract-init': { icon: 'cube' },
  'blockchain-create-contract-init': { icon: 'cube' },
  'blockchain-send-eth': { icon: 'dollar-sign' },
  'blockchain-burn-token': { icon: 'burn' },
  'blockchain-transfer-token': { icon: 'exchange-alt' },
  'endorsable-to-pagare': { icon: 'user-clock' },
  'add-confidential': { icon: 'user-secret' },
  'refuse-to-sign': { icon: 'user-times', color: 'danger' },
  'zoom-meeting-started': { icon: 'video' },
  'zoom-meeting-ended': { icon: 'video-slash' }
};